import React, {Component} from "react";
import {authStoreSelectors} from "../../../store/store";
import {AuthActionCreators} from "../../../actions/actionCreators";
import {connect} from "react-redux";
import {ActionCreator} from "../../../../../actions/actions";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import UserCard from "./UserCard/UserCard.component";
import UserRow from "./UserRow/UserRow.component";
import Drawer from "../../../../../utils/Drawer/Drawer.component";
import UserCreationPage from "../UserCreation/UserCreationPage.component";
import Paginator from "../../../../../utils/Paginator/Paginator.component";
import {checkAuthorization} from "../../../../../utils/Authorization/authorization";
import {AuthAPIRoutes} from "../../../api/auth.apiRoutes";
import "./UsersListPage.component.scss";
import {User} from "../../../reducers/users.reducer";
import _ from "lodash";

interface ServerSelectMenuOption {
    value: any;
    label: string;
}

export interface UsersListProps {
    getUsers: ActionCreator;
    usersListLoading: boolean;
    users_dict: {
        number_of_total_users: number;
        users: User[];
    };
    getUsersPrivileges: ActionCreator;
    usersPrivileges: ServerSelectMenuOption[];
    getSubsidiaries: ActionCreator;
}

export interface UsersListState {
    user_list_view: string;
    search_term: string;
    user_status: string;
    roles: {
        role_comparison_operator: string;
        role_ids_array: number[];
        select_values: number[];
    };
    open_popup: boolean;
    current_page: number;
    total_users_by_page: number;
    drawer_values: {
        drawer_title: "";
        user_obj: User;
        form_button_name: string;
        user_action: string;
    };
}

class UsersList extends Component<UsersListProps, UsersListState> {
    rolesFilter: React.RefObject<Components.SelectMenu>;

    constructor(props) {
        super(props);
        this.state = {
            user_list_view: "card",
            search_term: "",
            user_status: "1",
            roles: {
                role_comparison_operator: "",
                role_ids_array: [],
                select_values: []
            },
            open_popup: false,
            drawer_values: {
                drawer_title: "",
                user_obj: null,
                form_button_name: "",
                user_action: ""
            },
            current_page: 1,
            total_users_by_page: 12
        };
        this.applySearchToUsers = this.applySearchToUsers.bind(this);
        this.changeUserListView = this.changeUserListView.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.openPopUp = this.openPopUp.bind(this);
        this.closePopUp = this.closePopUp.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.rolesFilter = React.createRef();
        this.props.getSubsidiaries();
    }

    componentDidMount() {
        this.props.getUsersPrivileges();
        this.getUsers()
    }

    getUsers() {
        this.props.getUsers({
            search_term: this.state.search_term,
            current_page: this.state.current_page,
            total_users_by_page: this.state.total_users_by_page,
            roles: this.state.roles,
            user_status: this.state.user_status
        })
    }

    applySearchToUsers(e, search_type) {
        let updatedState = {...this.state};
        updatedState["current_page"] = 1;
        let search_value = e;
        if (search_type === "roles") {
            updatedState[search_type]["role_ids_array"] = [];
            updatedState[search_type]["select_values"] = e;
            updatedState[search_type]["role_comparison_operator"] = "in";
            e.map(id => {
                let usersPrivileges = this.props.usersPrivileges.find(role => role.value === id)
                updatedState[search_type]["role_ids_array"] =
                    updatedState[search_type]["role_ids_array"].concat(usersPrivileges['in'].map(i => i.id));
            })
        } else {
            search_value = e;
            updatedState[search_type] = search_value;
        }
        this.setState({
            search_term: updatedState["search_term"],
            current_page: 1,
            total_users_by_page: updatedState["total_users_by_page"],
            roles: updatedState["roles"],
            user_status: updatedState["user_status"]
        }, this.getUsersDebounce);
    }

    getUsersDebounce = _.debounce(() => {
        this.getUsers()
    }, 200)

    changeUserListView(e) {
        this.setState({user_list_view: e.currentTarget.id});
    }

    clearFilters() {
        let updatedState = {...this.state};
        this.rolesFilter.current.selectItem([]);
        this.rolesFilter.current.setDisplayString("Roles");

        this.setState({
            search_term: "",
            current_page: 1,
            total_users_by_page: updatedState["total_users_by_page"],
            roles: {
                role_comparison_operator: "",
                role_ids_array: [],
                select_values: []
            },
            user_status: "1"
        });
    }

    openPopUp(event, drawer_values) {
        this.setState({open_popup: false}, () =>
            this.setState({open_popup: true, drawer_values: drawer_values})
        );
    }

    closePopUp() {
        this.setState({
            open_popup: false,
            drawer_values: {
                drawer_title: "",
                user_obj: null,
                form_button_name: "",
                user_action: ""
            }
        });
    }

    onPageChange(currentPage) {
        this.setState({current_page: currentPage}, this.getUsers);
    }

    render() {
        const userStatus = [
            {
                value: "",
                label: "All"
            },
            {
                value: 1,
                label: "Active"
            },
            {
                value: 2,
                label: "Inactive"
            }
        ];
        return (
            <div id="UsersList" className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-6">
                            <h2 className="section-title">Users Management</h2>
                        </div>

                        <div className="col-6 center-vertical buttons-col">
                            {checkAuthorization({
                                route: AuthAPIRoutes.CREATE_USER
                            }) && (
                                <button
                                    className="new-user red-btn"
                                    onClick={e =>
                                        this.openPopUp(e, {
                                            drawer_title: "New User",
                                            user_obj: {
                                                id: null,
                                                first_name: "",
                                                last_name: "",
                                                email: "",
                                                is_superuser: false,
                                                profile_picture_base64: ""
                                            },
                                            form_button_name: "Create",
                                            user_action: "ADD_USER"
                                        })
                                    }
                                >
                                    <span>New User</span>
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="relative-pos">
                                <div className="search-area">
                                    <div className="row">
                                        <div className="adjustable-filters">
                                            <div className="user-filter">
                                                <label className="label">
                                                    Search
                                                </label>
                                                <input
                                                    className="input"
                                                    value={
                                                        this.state.search_term
                                                    }
                                                    type="text"
                                                    placeholder="Search"
                                                    onChange={event =>
                                                        this.applySearchToUsers(
                                                            event.target.value,
                                                            "search_term"
                                                        )
                                                    }
                                                />
                                            </div>
                                            <div className="user-filter">
                                                <label className="label">
                                                    Status
                                                </label>
                                                <Components.CheckboxGroup
                                                    key={this.state.user_status}
                                                    items={userStatus}
                                                    selected={
                                                        this.state.user_status
                                                    }
                                                    onChange={chosen_value =>
                                                        this.applySearchToUsers(
                                                            chosen_value,
                                                            "user_status"
                                                        )
                                                    }
                                                />
                                            </div>
                                            <div className="user-filter">
                                                <label className="label">
                                                    Roles
                                                </label>
                                                <Components.SelectMenu
                                                    key={`${this.state.roles.select_values}`}
                                                    ref={this.rolesFilter}
                                                    noValueLabel="Roles"
                                                    items={
                                                        this.props
                                                            .usersPrivileges
                                                    }
                                                    value={this.state.roles.select_values}
                                                    onChange={chosen_value =>
                                                        this.applySearchToUsers(
                                                            chosen_value,
                                                            "roles"
                                                        )
                                                    }
                                                    multipleSelection={true}
                                                />
                                            </div>
                                        </div>
                                        <div className="user-filter other-options">
                                            <div className="view-type">
                                                <button
                                                    className={
                                                        this.state
                                                            .user_list_view ===
                                                        "card"
                                                            ? "active"
                                                            : ""
                                                    }
                                                >
                                                    <i
                                                        onClick={e =>
                                                            this.changeUserListView(
                                                                e
                                                            )
                                                        }
                                                        className="icon-th-solid"
                                                        id="card"
                                                    />
                                                </button>
                                                <button
                                                    className={
                                                        this.state
                                                            .user_list_view ===
                                                        "list"
                                                            ? "active"
                                                            : ""
                                                    }
                                                >
                                                    <i
                                                        onClick={e =>
                                                            this.changeUserListView(
                                                                e
                                                            )
                                                        }
                                                        className="icon-align-justify-light"
                                                        id="list"
                                                    />
                                                </button>
                                            </div>
                                            <div>
                                                <button
                                                    className="clear-filters-btn"
                                                    onClick={this.clearFilters}
                                                >
                                                    Clear filters
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="users-content">
                            {this.props.usersListLoading &&
                                <div className="users-lists-loading">
                                    <Components.LoadingRipple
                                        width={"100px"}
                                        height={"100px"}
                                    />
                                </div>
                            }
                            {!this.props.usersListLoading && this.props.users_dict.users && this.props.users_dict.users.length === 0 && (
                                <div className="users-list-no-user">
                                    No Users records to display. Please select different
                                    values to try again.
                                </div>
                            )}
                            {!this.props.usersListLoading && checkAuthorization({
                                    route: AuthAPIRoutes.GET_USERS
                                }) &&
                                (this.state.user_list_view === "card" ? (
                                    this.props.users_dict.users instanceof
                                    Array &&
                                    this.props.users_dict.users.map(user => (
                                        <UserCard
                                            key={user.id}
                                            user={user}
                                            filters={this.state}
                                            open_pop_up={this.openPopUp}
                                        />
                                    ))
                                ) : (
                                    <div className="users-table">
                                        <table>
                                            <thead>
                                            <tr>
                                                <td>Users</td>
                                                <td>Email</td>
                                                <td>Subsidiaries</td>
                                                <td>Role</td>
                                                <td>Status</td>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.props.users_dict
                                                    .users instanceof Array &&
                                                this.props.users_dict.users.map(
                                                    user => (
                                                        <UserRow
                                                            key={user.id}
                                                            user={user}
                                                            filters={
                                                                this.state
                                                            }
                                                            open_pop_up={
                                                                this
                                                                    .openPopUp
                                                            }
                                                        />
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                ))}
                        </div>
                    </div>
                    {this.state.open_popup && (
                        <Drawer
                            title={this.state.drawer_values.drawer_title}
                            onClose={this.closePopUp}
                        >
                            <UserCreationPage
                                drawer_values={this.state.drawer_values}
                                filters={this.state}
                            />
                        </Drawer>
                    )}
                </div>
                <div className="row users-pagination container">
                    <div className="col-12 center-vertical paginator">
                        {this.props.users_dict.number_of_total_users > 0 && (
                            <Paginator
                                currentPage={this.state.current_page}
                                totalPages={Math.ceil(
                                    this.props.users_dict
                                        .number_of_total_users /
                                    this.state.total_users_by_page
                                )}
                                onPageChange={this.onPageChange}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    users_dict: authStoreSelectors.users_dict(state),
    usersPrivileges: authStoreSelectors.usersPrivileges(state),
    usersListLoading: authStoreSelectors.usersListLoading(state)
});

const mapDispatchToProps = {
    getUsers: AuthActionCreators.getUsers,
    getUsersPrivileges: AuthActionCreators.getUsersPrivileges,
    getSubsidiaries: AuthActionCreators.getSubsidiaries
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersList);
